import { render, staticRenderFns } from "./connection.vue?vue&type=template&id=de5f12e2&scoped=true&"
import script from "./connection.vue?vue&type=script&lang=js&"
export * from "./connection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5f12e2",
  null
  
)

export default component.exports